module.exports = __webpack_public_path__ + "static/img/wget.9120d605.png";